// The two things /margin adds to the summary page, kept out of it. The page reads dozens of
// fields that only exist once a registration is finished, which makes it hard to look at
// alone; these two are small enough to be tested on their own.

import React from 'react';
import { plainMessage } from '../lib/marginHelpers';

/** Which bank the Margin Account's RDN will be opened at, in place of the Regular Account's row. */
export function MarginBankRow({ store }) {
    const bank = store.state.registration.rdn_bank_margin;
    const text = (bank && typeof bank === 'object') ? bank.label : String(bank || '').toUpperCase();
    return (
        <tr>
            <td width="20%">{store.dispatch({ type: 'translate', text: 'margin_summary_rdn_bank' })}</td>
            <td width="1%">:</td>
            <td data-testid="margin-summary-bank">{text}</td>
        </tr>
    );
}

/**
 * Why the final submit was refused.
 *
 * This page showed no error at all, which mattered little while its only failure was a dropped
 * line. A margin submission can be refused for a reason the client can act on -- a document
 * missing, the account no longer found -- and a button that does nothing is not an answer.
 * Margin mode only: no other path is changed.
 */
export function MarginSummaryError({ store }) {
    if (!store.state.marginStat) return null;
    const raw = store.state.errors.global_message;
    if (!raw) return null;
    const msg = typeof raw === 'object' ? plainMessage(raw, store.state.lang) : raw;
    return (
        <div
            data-testid="margin-summary-error"
            style={{ margin: '0 0 16px', padding: 12, borderRadius: 6, background: '#fdecea', border: '1px solid #f5c6cb', color: '#721c24' }}
        >
            {store.dispatch({ type: 'translate', text: msg }) || msg}
        </div>
    );
}
